// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Button from "@mui/material/Button";
import { Grid } from "@mui/material";

function Copyright() {
  const currentYear = new Date().getFullYear();
  const copyright = "© " + currentYear + " WSO2 LLC";
  return (
    <Typography variant="body2" color="text.secondary">
      {copyright}
      <Link color="inherit" href="/" underline="none">
        <Button
          sx={{
            ":hover": {
              bgcolor: "background.default",
              color: "secondary.main",
            },
          }}
          variant="text"
        >
          Home
        </Button>
      </Link>{" "}
      <Link color="inherit" href="https://wso2.com/legal/" underline="none">
        <Button
          sx={{
            ":hover": {
              bgcolor: "background.default",
              color: "secondary.main",
            },
          }}
          variant="text"
        >
          Legal
        </Button>
      </Link>{" "}
      <Link color="inherit" href="http://wso2.com/" underline="none">
        <Button
          sx={{
            ":hover": {
              bgcolor: "background.default",
              color: "secondary.main",
            },
          }}
          variant="text"
        >
          WSO2
        </Button>
      </Link>{" "}
    </Typography>
  );
}

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        py: 1,
        mt: "auto",
        borderTop: (theme) => `2px solid ${theme.palette.secondary.main}`,
        width: "100vw",
        position: "relative",
        bottom: 0,
        alignContent: "left",
        backgroundColor: "background.default",
      }}
    >
      <Container>
        <Grid container>
          <Copyright />
        </Grid>
      </Container>
    </Box>
  );
}
